import { useState, createContext, useContext } from "react"

const ProjectContext = createContext({})
export const useProject = () => useContext(ProjectContext)

export default ({ children, userServer, projectServer, settingServer }) => {
	const [user, setUser] = useState(userServer)
	const [project, setProject] = useState(projectServer ? projectServer : null)
	const [setting, setSetting] = useState(settingServer ? settingServer : null)

	const userHandler = (value) => {
		value
			? setUser({
					...user,
					...value,
			  })
			: setUser(null)
	}

	const projectHandler = (value) => {
		value
			? setProject({
					...project,
					...value,
					zoom: value.zoom
						? parseFloat(parseFloat(value.zoom).toFixed(1))
						: 1,
					mode: value.mode ? value.mode : "cursor",
			  })
			: setProject(null)
	}

	const settingHandler = (value) => {
		value
			? setSetting({
					...setting,
					...value,

			  })
			: setSetting(null)
	}

	return (
		<>
			{/* <Head>
				<title>EBASE</title>
				<meta
					name='viewport'
					content='initial-scale=1.0, width=device-width, maximum-scale=1.0, user-scalable=no'
				/>
			</Head> */}
			<ProjectContext.Provider
				value={{
					user,
					project,
					setting,
					setUser: userHandler,
					setProject: projectHandler,
					setSetting: settingHandler,
				}}
			>
				{children}
			</ProjectContext.Provider>
		</>
	)
}
